// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2fjB8","log":"ModalInventoryLogs_log__VR6cV","date":"ModalInventoryLogs_date__2XLbn","userName":"ModalInventoryLogs_userName__1pLeZ"};